export const TICKER_SPEED_SEC = { super_lambat: 75, lambat: 45, sedang: 28, cepat: 14 };
export const TICKER_SIZE_PX = { kecil: 13, sedang: 16, besar: 21 };

export const tickerStyle = (speed = "sedang", size = "sedang", extraPx = 0) => ({
  animationDuration: `${TICKER_SPEED_SEC[speed] || 28}s`,
  fontSize: `${(TICKER_SIZE_PX[size] || 16) + extraPx}px`,
});
